import React, { FC } from 'react'
import { MenuItem } from '@chakra-ui/react'
export interface DropdownItemProps {
  label: string
  itemValue: string
  onClick: () => void
}

export const DropdownItem: FC<DropdownItemProps> = ({ itemValue, onClick, label }) => (
  <MenuItem
    key={`option-${itemValue}`}
    borderRadius="medium"
    role="option"
    paddingX={4}
    paddingY={2}
    _hover={{
      color: 'purple',
      backgroundColor: 'purpleAlpha',
    }}
    _active={{
      color: 'purple',
      backgroundColor: 'purpleAlpha',
    }}
    onClick={() => onClick()}
    tabIndex={0}
    aria-label={`button-${label}`}
    _focus={{
      borderColor: 'brand',
      boxShadow: '0 0 0 2px #5bce4c',
    }}
  >
    {label}
  </MenuItem>
)
